<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED"><span class="ePub-I">For Laura Marchand, my high school sweetheart and the first person to ever believe in me. The world deserved so much more of her light.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?85c2c3ce